import { MaintenanceWindowsDeleteDialogBaseDataProvider } from './MaintenanceWindowsDeleteDialogBaseDataProvider';
import { PolicyImpactData } from '../types';
import { sanitizeObject } from '../../../utils/sanitization.utils';

export class MaintenanceWindowsDeleteDialogGzDataProvider extends MaintenanceWindowsDeleteDialogBaseDataProvider {
  public async getMaintenanceWindowOperationSummary(
    companyId: string,
    maintenanceWindowIds: string[]
  ): Promise<PolicyImpactData> {
    try {
      const result = await this.dependencies.api.clients.MaintenanceWindows.getMaintenanceWindowOperationSummary(
        companyId,
        maintenanceWindowIds
      );

      if (!result || typeof result.policyCount === undefined || typeof result.policyNames === undefined) {
        throw new Error('Invalid response of getMaintenanceWindowOperationSummary');
      }

      return sanitizeObject(result);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
